define(
  'modules/controller',
  [
    'jquery',
    'modules/animation',
    'modules/navigation',
    'modules/utils',
    'modules/tracking',
    'modules/tile-nav',
    'modules/feature-view',
    'modules/spin-loader',
    'modules/menu'
  ],
  function (
    $,
    M_Animation,
    M_Navigation,
    M_Utils,
    M_Tracking,
    M_TileNav,
    M_FeatureView,
    M_SpinLoader,
    M_Menu
  ) {
    'use strict';

    var classes = {
      isActive: 'is--active'
    };
    var selectors = {
      screen: '.js-screen',
      screenIntro: '.js-screen-intro',
      screenReveal: '.js-screen-reveal',
      showScreenRevealLink: '.js-show-screen-reveal',
      screenLoading: '.js-screen-loading',
      revealVideo: '.js-anim-reveal-media',
      screenNav: '.js-screen-nav',
      screenNavExterior: '.js-screen-nav-exterior',
      screenNavInterior: '.js-screen-nav-interior',
      screenFeatureView: '.js-screen-feature'
    };
    var state = {
      revealFinished: false
    };
    var $showReveal;
    var $revealVideo;


    function init () {
      getElems();
      bindEvents();
    }

    function getElems () {
      $showReveal = $(selectors.showScreenRevealLink);
      $revealVideo = $(selectors.revealVideo);
    }

    function bindEvents () {
      var carViews = M_Utils.getCarViews();
      var subViews = M_Utils.getSubViews();

      $showReveal.on('click', onShowRevealClick);

      M_Utils.addListener('nx-assetloaded-loadingvideo', function () {
        changeScreenIntro();
      });
      M_Utils.addListener('nx-loading-interior', function (e) {
        changeScreenLoading(carViews.interior, e.detail.subView, e.detail.onComplete);
      });
      M_Utils.addListener('nx-loading-exterior', function (e) {
        changeScreenLoading(carViews.exterior, e.detail.subView, e.detail.onComplete);
      });
      M_Utils.addListener('nx-loading-complete', function () {
        if (!state.revealFinished) {
          return;
        }
        M_Animation.playSequence('screenLoadingExit', onLoadingExitComplete);
      });
      M_Utils.addListener('nx-show-nav-exterior', function () {
        changeScreenNav(carViews.exterior);
      });
      M_Utils.addListener('nx-hide-nav-exterior', function () {
        closeScreenNav(carViews.exterior);
      });
      M_Utils.addListener('nx-show-nav-interior', function () {
        changeScreenNav(carViews.interior);
      });
      M_Utils.addListener('nx-hide-nav-interior', function () {
        closeScreenNav(carViews.interior);
      });

      // Hotspot click
      M_Utils.addListener('VIDEONAVIGATION', function (e) {
        M_Menu.closeMenu();

        if (e.detail.data.type === 'navigation' ) {
          changeScreenLoading(e.detail.destination, subViews.features, function () {
            M_TileNav.loadView(e.detail.destination, subViews.features, true);
          });

          return;
        }

        changeScreenFeatureView(e.detail.destination);
      });

      M_Utils.addListener('nx-close-feature-view', function () {
        M_Animation.playSequence('screenFeatureViewExit', closeAllScreens);
      });
    }

    function changeScreen (screenName, onAnimationComplete) {
      $(selectors.screen).removeClass(classes.isActive);

      var screenSelector = selectors[screenName];
      if (!screenSelector) {
        return;
      }

      $(screenSelector).addClass(classes.isActive);

      M_Animation.playSequence(screenName, onAnimationComplete);
    }

    function changeScreenIntro () {
      changeScreen('screenIntro');
      M_Utils.setSelectedPageName(M_Utils.getPageNames().intro);
      M_Tracking.trackPageView(window.location.pathname + M_Utils.getSelectedView() + '/onboarding');
    }

    function changeScreenReveal () {
      changeScreen('screenReveal', onRevealSequenceComplete);
      loadInitialSpinView();
      M_Utils.setSelectedPageName(M_Utils.getPageNames().reveal);
      M_Tracking.trackPageView(window.location.pathname + M_Utils.getSelectedView() + '/welcome');
    }

    function changeScreenLoading (view, subView, onComplete) {
      changeScreen('screenLoading');
      M_Utils.setSelectedPageName(M_Utils.getPageNames().experience);
      var selectedSubView = subView ? subView : M_Utils.getSelectedSubView();
      M_Animation.playSequence('screenLoading' + M_Utils.capitalizeFirstLetter(view) + M_Utils.capitalizeFirstLetter(selectedSubView), onComplete);
    }

    function changeScreenNav (view) {
      var carViews = M_Utils.getCarViews();

      if (!carViews.hasOwnProperty(view)) {
        return;
      }

      var screenSelector = selectors['screenNav' + M_Utils.capitalizeFirstLetter(view)];
      var $screen = $(screenSelector);
      var $otherScreen = $(selectors.screenNav + ':not(' + screenSelector + ')');
      var otherView = view === carViews.exterior ? carViews.interior : carViews.exterior; // will need refactoring if required to support more than 2 carViews

      if ($screen.hasClass(classes.isActive)) {
        closeScreenNav(view);
        return;
      }

      if ($otherScreen.hasClass(classes.isActive)) {
        closeScreenNav(otherView, function () {
          openScreenNav(view);
        });

        return;
      }

      openScreenNav(view);
    }

    function changeScreenFeatureView (view) {
      M_Tracking.trackPageView(window.location.pathname + M_Utils.getSelectedView() + '/feature/' + view);

      M_FeatureView.displayMediaForView(view, function () {
        changeScreen('screenFeatureView', function () {
          M_FeatureView.displayView(view);
        });
      });
    }

    function openScreenNav (view) {
      var carViews = M_Utils.getCarViews();

      if (!carViews.hasOwnProperty(view)) {
        return;
      }

      M_Tracking.trackPageView(window.location.pathname + M_Utils.getSelectedView() + '/explore/');

      M_Navigation.setActiveControl(view);
      M_TileNav.initSlider(view);
      changeScreen('screenNav' + M_Utils.capitalizeFirstLetter(view));
    }

    function closeScreenNav (view, onComplete) {
      var carViews = M_Utils.getCarViews();

      if (!carViews.hasOwnProperty(view)) {
        return;
      }

      M_Navigation.setActiveControl('');
      M_Animation.playSequence('screenNav' + M_Utils.capitalizeFirstLetter(view) + 'Exit', function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }

        onScreenNavExitComplete(view);
      });
    }

    function hideScreenNav (view) {
      var carViews = M_Utils.getCarViews();

      if (!carViews.hasOwnProperty(view)) {
        return;
      }

      $(selectors['screenNav' + M_Utils.capitalizeFirstLetter(view)]).removeClass(classes.isActive);
    }

    function loadInitialSpinView () {
      var carViews = M_Utils.getCarViews();
      var subViews = M_Utils.getSubViews();

      M_TileNav.loadView(carViews.exterior, subViews.features, true, true);
    }

    function onShowRevealClick (e) {
      $revealVideo[0].play();
      M_Tracking.trackEvent('click-cta', $(e.currentTarget).attr('id'));
      M_Animation.playSequence('screenIntroExit', changeScreenReveal);
      M_Utils.triggerEvent('AUDIOINIT');
    }

    function onRevealSequenceComplete () {
      M_Animation.playSequence('screenRevealExit', function () {
        state.revealFinished = true;
        closeAllScreens();
        M_Animation.playSequence('revealSpinContainer', function () {
          M_Navigation.showControls(true);
          M_Tracking.trackPageView(window.location.pathname + M_Utils.getSelectedView() + '/experience/');
        });
      });
    }

    function onLoadingExitComplete () {
      closeAllScreens();
      M_Navigation.showControls(true);
    }

    function onScreenNavExitComplete (view) {
      M_TileNav.destroySlider(view);
      hideScreenNav(view);
    }

    function closeAllScreens () {
      $(selectors.screen).removeClass(classes.isActive);
    }


    return {
      init: init
    }
});

